// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1J4B8","label":"Radio_label__1OrdJ","checkMark":"Radio_checkMark___v21o","disabled":"Radio_disabled__3VCvv"};